import _regeneratorRuntime from 'babel-runtime/regenerator';

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(comprobarCaducidad);

import { put } from 'redux-saga/effects';
import { setCaducado, setMensajeCaducidad } from '../../actions';
import pulsarDescodificar from '../../caducidad';
import * as Util from '../../util';

function getFecha(year, mes, dia) {
  var fecha = new Date(year, mes - 1, dia);
  fecha.setHours(0, 0, 0, 0);
  return fecha;
}

function getFechaDeHoy() {
  var hoy = new Date();
  hoy.setHours(0, 0, 0, 0);
  return hoy;
}

function formatFecha(fecha) {
  var year = Number(fecha.substr(0, 4));
  var mes = Number(fecha.substr(4, 2));
  var dia = Number(fecha.substr(6, 2));
  return [dia, mes, year].join('/');
}

function parseFechaYYYYMMDD(fecha) {
  var year = Number(fecha.substr(0, 4));
  var mes = Number(fecha.substr(4, 2));
  var dia = Number(fecha.substr(6, 2));

  if (isNaN(year) || isNaN(mes) || isNaN(dia)) {
    return null;
  }

  return getFecha(year, mes, dia);
}

function getFechaUltimoArranque() {
  return Number(Util.getStorageData('fua'));
}

function validarHasta(fecha_hasta) {
  var fechaUltimoArranque = getFechaUltimoArranque(); //  getFechaDeHoy()

  var fechaLimiteDate = parseFechaYYYYMMDD(fecha_hasta);

  if (fechaLimiteDate === null) {
    return false;
  }

  if (fechaLimiteDate.getTime() < fechaUltimoArranque) {
    return false;
  }

  return true;
}

function numDiasEntreFechas(fecha1, fecha2) {
  return Math.floor((fecha2.getTime() - fecha1.getTime()) / (1000 * 60 * 60 * 24));
}

function esDiaDeAviso(fecha_aviso, frecuencia_aviso, mensaje) {
  // window.console.log('esDiaDeAviso', fecha_aviso, frecuencia_aviso)
  var fechaAvisoDate = parseFechaYYYYMMDD(fecha_aviso);

  if (fechaAvisoDate === null) {
    return false;
  }

  var fechaHoy = getFechaDeHoy();
  /* window.console.log('esDiaDeAviso', 
      {
          fechaAvisoDate, 
          fechaHoy
      }
  )*/
  // hemos alcanzado la fecha de aviso ?

  if (fechaHoy.getTime() < fechaAvisoDate.getTime()) {
    // window.console.log('esDiaDeAviso -> no hemos alcanzado la fecha de aviso')
    return false;
  } // es dia de aviso segun la frecuenta ?


  var diasTranscurridos = numDiasEntreFechas(fechaAvisoDate, fechaHoy); // window.console.log('esDiaDeAviso', { diasTranscurridos, frecuencia_aviso, modulo: diasTranscurridos % frecuencia_aviso })

  if (diasTranscurridos % frecuencia_aviso !== 0) {
    // window.console.log('esDiaDeAviso -> no es dia de aviso por la frecuencia')
    return false;
  }

  return true;
}

function getMarcaUltimoAviso() {
  var marca = Util.getStorageData('mua') || {};
  marca.time = marca.time || getFechaDeHoy().getTime();
  marca.mostrado = marca.mostrado || false;
  Util.setStorageData('mua', marca);
  return marca;
}

function setFechaUltimoArranque() {
  var hoy = getFechaDeHoy().getTime();
  var valorActualUltimoArranque = Util.getStorageData('fua') || hoy;
  var fechaUltimoArranque = Math.max(hoy, valorActualUltimoArranque);
  Util.setStorageData('fua', fechaUltimoArranque);
}

export default function comprobarCaducidad(_ref) {
  var data = _ref.data,
      key = _ref.key,
      mensajeCAD2 = _ref.mensajeCAD2,
      mensajeCAD3 = _ref.mensajeCAD3,
      mensajeCAD5 = _ref.mensajeCAD5,
      mensajeCAD6 = _ref.mensajeCAD6,
      mensajeCAD7 = _ref.mensajeCAD7;

  var cad, _cad$split, data_key, fecha_hasta, fecha_aviso, frecuencia_aviso, anno_hasta, infoFechaCAD, _getMarcaUltimoAviso, time, mostrado, msg;

  return _regeneratorRuntime.wrap(function comprobarCaducidad$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          setFechaUltimoArranque(); // configGeneral debe contener data y key

          if (!(!data || !key)) {
            _context.next = 5;
            break;
          }

          _context.next = 4;
          return put(setCaducado(true, mensajeCAD6));

        case 4:
          return _context.abrupt('return');

        case 5:
          cad = pulsarDescodificar(data);
          _cad$split = cad.split('###'), data_key = _cad$split[0], fecha_hasta = _cad$split[2], fecha_aviso = _cad$split[3], frecuencia_aviso = _cad$split[4];

          if (window.modoTrabajo) {
            window.console.log('CAD: ' + formatFecha(fecha_hasta));
          }

          anno_hasta = Number(fecha_hasta.substr(0, 4));
          infoFechaCAD = mensajeCAD7 && anno_hasta < 2900 ? {
            visible: true,
            mensaje: mensajeCAD7.replace(/##/, formatFecha(fecha_hasta))
          } : {
            visible: false,
            mensaje: formatFecha(fecha_hasta)
          };
          _context.next = 12;
          return put(setMensajeCaducidad(infoFechaCAD));

        case 12:
          if (!(key !== data_key)) {
            _context.next = 16;
            break;
          }

          _context.next = 15;
          return put(setCaducado(true, mensajeCAD6));

        case 15:
          return _context.abrupt('return');

        case 16:
          if (validarHasta(fecha_hasta)) {
            _context.next = 20;
            break;
          }

          _context.next = 19;
          return put(setCaducado(true, mensajeCAD2));

        case 19:
          return _context.abrupt('return');

        case 20:
          if (!(getFechaDeHoy().getTime() < getFechaUltimoArranque())) {
            _context.next = 24;
            break;
          }

          _context.next = 23;
          return put(setCaducado(true, mensajeCAD5));

        case 23:
          return _context.abrupt('return');

        case 24:
          // si hoy ya hemos mostrado un aviso, no hace falta mostrarlo de nuevo
          _getMarcaUltimoAviso = getMarcaUltimoAviso(), time = _getMarcaUltimoAviso.time, mostrado = _getMarcaUltimoAviso.mostrado; // window.console.log('comprobarCaducidad -> marca', {time, mostrado })

          if (!(mostrado && time === getFechaDeHoy().getTime())) {
            _context.next = 29;
            break;
          }

          _context.next = 28;
          return put(setCaducado(false, ''));

        case 28:
          return _context.abrupt('return');

        case 29:
          if (!esDiaDeAviso(fecha_aviso, frecuencia_aviso)) {
            _context.next = 34;
            break;
          }

          msg = mensajeCAD3.replace(/##/, formatFecha(fecha_hasta)).replace(/##/, numDiasEntreFechas(getFechaDeHoy(), parseFechaYYYYMMDD(fecha_hasta)));
          _context.next = 33;
          return put(setCaducado(false, msg));

        case 33:
          return _context.abrupt('return');

        case 34:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}